<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="reward-num"><span>+</span><span>{{amount}}</span><span>元</span></div>
      <div class="sub-title">成功领取团队奖励</div>
      <div class="btn-middle" @click='hide()'>返回</div>
      <div class="btn-middle" @click="share()">邀请更多队员</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 258px;
    padding: 30px 42px;
    text-align: center;

    .reward-num {
      margin-bottom: 10px;

      span:first-child {
        font-size: 20px;
        color: #F75946;
        margin-right: 2px;

        @include roboto();
      }

      span:nth-child(2) {
        font-size: 36px;
        color: #F75946;
        margin-right: 2px;

        @include roboto();
      }

      span:nth-child(3) {
        font-size: 13px;
        color: #F75946;

        @include semibold();
      }
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto 10px;;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    props: {
      amount: {
        type: Number,
        default: 0
      }
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
        location.reload()
      },
      share () {
        this.$refs.p.hide()
        $bus.$emit('shareList')
      }
    }
  }
</script>
